import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { SharedModule } from '../shared/modules/shared.module';

import { routing } from './quote.routing';
import { AppComponent } from '../app.component';
import { ListComponent } from './list/list.component';
import { NoteListComponent } from './note-list/note.list.component';
import { AddComponent } from './add/add.component';
import { SummaryComponent} from './summary/summary.component';
import { ConvertDialog } from './convert-dialog/convert.dialog';

import { AuthGuard } from '../auth.guard';
import { QuoteService } from './services/quote.service';
import { FileService } from '../shared/services/file.service';
import { ListMobileComponent } from './list/list-mobile/list-mobile.component';
import { ListDesktopComponent } from './list/list-desktop/list-desktop.component';
import { SummaryMobileComponent } from './summary/summary-mobile/summary-mobile.component';
import { SummaryDesktopComponent } from './summary/summary-desktop/summary-desktop.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forRoot(routing, {}),
        SharedModule
    ],
    declarations: [ListComponent, AddComponent,
        NoteListComponent, SummaryComponent,
        ConvertDialog, ListMobileComponent, ListDesktopComponent, SummaryMobileComponent, SummaryDesktopComponent],
    exports: [],
    providers: [AppComponent, AuthGuard, QuoteService, FileService]
})
export class QuoteModule { }
